import * as React from 'react';
import { Image } from 'semantic-ui-react';
import { Props, ActionProps, propTypes } from './props';
import { Retransition } from '../../../../retransition';

export default class ActionsCellRenderer extends React.Component<Props> {
  static propTypes = propTypes;

  render() {
    const actionProps = this.props.colDef.cellRendererParams as ActionProps;

    return (
      <div className="action-button">
        <Retransition
          animation="pulse"
          duration={200}
          await={true}
          onClick={this.callback}
        >
          <Image src={actionProps.icon} />
        </Retransition>
      </div>
    );
  }

  private callback = () => {
    const actionProps = this.props.colDef.cellRendererParams as ActionProps;
    actionProps.callback(this.props.value);
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/actions/component.tsx